const viewerState  = () => {
    return {
        definitions: null,
        requestSuccess: true,
        currentDocument: null,
        documents: {},
        dataAvailable: true,
        definitionAvailable:true,
        sharePath: null,
        serverStatus: true,
        serviceUnavailable: false
    };
  };


  export default viewerState;